import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    input: {
        width: '100%',
        position: 'relative',

        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E5E9ED',
        },
    },
    wrapper: {
        // margin: '12px',
        // marginLeft: 0,

        '& .MuiOutlinedInput-root': {
            // backgroundColor: '#E5E9ED',
        },

        '& .Mui-focused': {
            backgroundColor: '#F7F7FA !important',
        },

        [theme.breakpoints.down('md')]: {
            margin: '8px 0',
        },
    },
}));
